import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { Link } from 'react-router'

import { truncate } from 'utils/strings'

import colors from 'components/utils/colors'
import Badge from 'components/Shared/Badge/Index'

import { MEGA_MENU_LINE_LENGTH } from 'constants/constants'

const underlineTabCss = css`
  content: "";
  background: ${colors.primary40};
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
`

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  color: ${colors.secondary40};
  gap: 2px;
  height: 24px;
  padding: 4px 8px;
  box-sizing: border-box;

  &:hover {
    background: ${colors.primary95};

    &:after {
      ${underlineTabCss}
    }
  }

  &:after {
    content: "";
    margin: auto;
    background: transparent;
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 2px;
  }

  ${props => props.$active && css`
    &:after {
      ${underlineTabCss}
    }
  `}
`

const Title = styled.div`
  font-size: 12px;
  ${props => props.$active && css`
    color: ${colors.primary35};
  `}
`

const TabItem = ({ itemInfo, isActive }) => {
  const { title, badge, to } = itemInfo
  const showBadge = typeof badge !== 'undefined'

  return (
    <StyledLink $active={isActive} to={to}>
      <Title $active={isActive} data-test='tab-item-title'>{truncate(title, MEGA_MENU_LINE_LENGTH)}</Title>
      {showBadge && (
        <Badge color={colors.secondary90} margin='0px' data-test='tab-item-badge'>
          {truncate(badge, MEGA_MENU_LINE_LENGTH)}
        </Badge>
      )}
    </StyledLink>
  )
}

TabItem.propTypes = {
  itemInfo: PropTypes.object.isRequired,
  isActive: PropTypes.bool,
}

export default TabItem
